












import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Top3Cell extends Vue {
  @Prop({ default: "--" }) private readonly title?: string;
  @Prop({ default: 0 }) private readonly count?: string | number;
  @Prop({ default: 1 }) private readonly top?: number | string;

  get cellNumberObj() {
    return "cell-number-" + this.top;
  }
}
